"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _alphapointApexApi = require("alphapoint-apex-api");
var _level2Selectors = require("../selectors/level2Selectors");
var _level2Actions = require("../actions/level2Actions");
var _config = _interopRequireDefault(require("../../config"));
var _level2SubscriptionService = _interopRequireDefault(require("../../services/subscriptions/level2SubscriptionService"));
var _apex = _interopRequireDefault(require("../../apex"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var level2MonitorInterval = _config["default"].Middleware.level2MonitorInterval;
var RPC_TIMEOUT_MS = 10000;
var SUBSCRIBE_TIMEOUT_MS = 30000;
function withTimeout(promise, ms) {
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Operation';
  var timeoutId;
  var timeoutPromise = new Promise(function (_, reject) {
    timeoutId = setTimeout(function () {
      return reject(new Error("".concat(label, " timed out after ").concat(ms, "ms")));
    }, ms);
  });
  return Promise.race([promise, timeoutPromise])["finally"](function () {
    return clearTimeout(timeoutId);
  });
}
var intervalSingleton;
var subscriptionInProgress = false;
var pendingSubscriptionInstrumentId = null;
var orderBookSanityCheck = function orderBookSanityCheck(state) {
  var buy = (0, _level2Selectors.level2BuySelector)(state, {});
  var sell = (0, _level2Selectors.level2SellSelector)(state, {});
  var InsideBid = (0, _get["default"])(buy, [buy.length - 1, 'Price'], 0);
  var InsideAsk = (0, _get["default"])(sell, [0, 'Price'], Number.MAX_VALUE);
  return InsideBid > InsideAsk;
};
var level2monitor = function level2monitor(store) {
  return function (next) {
    var handler = function handler() {
      var instrumentId = store.getState().apexCore.instrument.selectedInstrumentId;
      if (!instrumentId) {
        return;
      }
      var isInitialized = _level2SubscriptionService["default"].isInitialized(instrumentId);
      if (document.hidden && isInitialized) {
        store.dispatch((0, _level2Actions.unsubscribeLevel2)(instrumentId));
      } else {
        store.dispatch((0, _level2Actions.subscribeToLevel2)(instrumentId));
      }
    };
    document.addEventListener('visibilitychange', handler);
    function subscribe() {
      return _subscribe.apply(this, arguments);
    }
    function _subscribe() {
      _subscribe = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var instrumentId, pending, currentInstrumentId;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              instrumentId = store.getState().apexCore.instrument.selectedInstrumentId;
              if (instrumentId) {
                _context3.n = 1;
                break;
              }
              console.warn('No instrument selected for Level2 subscription');
              return _context3.a(2);
            case 1:
              if (!subscriptionInProgress) {
                _context3.n = 2;
                break;
              }
              // Silently queue the request - this is normal behavior
              pendingSubscriptionInstrumentId = instrumentId;
              return _context3.a(2);
            case 2:
              subscriptionInProgress = true;
              _context3.p = 3;
              _context3.n = 4;
              return withTimeout(_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var updates, dataRetrieved, snapshot, data, currentId, mappedData, resubscribeRes, _data, _currentId, _mappedData, _t, _t2, _t3;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.p = _context2.n) {
                    case 0:
                      if (!_level2SubscriptionService["default"].isInitialized()) {
                        _context2.n = 2;
                        break;
                      }
                      _context2.n = 1;
                      return _level2SubscriptionService["default"].stop();
                    case 1:
                      store.dispatch((0, _level2Actions.unsubscribeLevel2)(instrumentId));
                    case 2:
                      _context2.n = 3;
                      return store.dispatch((0, _level2Actions.requestLevel2Data)(instrumentId));
                    case 3:
                      _context2.p = 3;
                      _context2.n = 4;
                      return _level2SubscriptionService["default"].initSubscription(instrumentId);
                    case 4:
                      updates = _context2.v;
                      if (updates.result !== false) {
                        store.dispatch((0, _level2Actions.getAllLevel2)(updates));
                        _level2SubscriptionService["default"].subscribe(function (updates) {
                          var _updates$;
                          if ((updates === null || updates === void 0 || (_updates$ = updates[0]) === null || _updates$ === void 0 ? void 0 : _updates$.ProductPairCode) === instrumentId) {
                            store.dispatch((0, _level2Actions.level2Updates)(updates));
                          }
                        });
                      }
                      _context2.n = 17;
                      break;
                    case 5:
                      _context2.p = 5;
                      _t = _context2.v;
                      if (!((_t === null || _t === void 0 ? void 0 : _t.errorcode) === 909)) {
                        _context2.n = 16;
                        break;
                      }
                      // Since we're already subscribed, we need to:
                      // 1. Mark the service as initialized for this instrument
                      _level2SubscriptionService["default"].markAsInitialized(instrumentId);

                      // 2. Set up the event listener for updates
                      _level2SubscriptionService["default"].subscribe(function (updates) {
                        var _updates$2;
                        if ((updates === null || updates === void 0 || (_updates$2 = updates[0]) === null || _updates$2 === void 0 ? void 0 : _updates$2.ProductPairCode) === instrumentId) {
                          store.dispatch((0, _level2Actions.level2Updates)(updates));
                        }
                      });

                      // 3. Try multiple methods to get the initial order book data
                      dataRetrieved = false; // Method 1: Try GetL2Snapshot
                      _context2.p = 6;
                      _context2.n = 7;
                      return withTimeout(_apex["default"].connection.RPCPromise('GetL2Snapshot', {
                        OMSId: 1,
                        InstrumentId: instrumentId,
                        Depth: 250
                      }), RPC_TIMEOUT_MS, 'GetL2Snapshot');
                    case 7:
                      snapshot = _context2.v;
                      if (snapshot && snapshot.o) {
                        data = JSON.parse(snapshot.o);
                        if (Array.isArray(data) && data.length > 0) {
                          currentId = store.getState().apexCore.instrument.selectedInstrumentId;
                          if (currentId !== instrumentId) {
                            dataRetrieved = true; // prevent Method 2 from running
                          } else {
                            mappedData = data.map(function (x) {
                              return new _alphapointApexApi.Level2(x);
                            });
                            store.dispatch((0, _level2Actions.getAllLevel2)(mappedData));
                            dataRetrieved = true;
                          }
                        } else if (data) {
                          console.error('GetL2Snapshot returned unexpected data:', data);
                        }
                      }
                      _context2.n = 9;
                      break;
                    case 8:
                      _context2.p = 8;
                      _t2 = _context2.v;
                      console.error('Failed to get Level2 snapshot after 909:', _t2);
                    case 9:
                      if (dataRetrieved) {
                        _context2.n = 15;
                        break;
                      }
                      _context2.p = 10;
                      _context2.n = 11;
                      return withTimeout(_apex["default"].connection.RPCPromise('UnsubscribeLevel2', {
                        OMSId: 1,
                        InstrumentId: instrumentId
                      }), RPC_TIMEOUT_MS, 'UnsubscribeLevel2');
                    case 11:
                      _context2.n = 12;
                      return new Promise(function (resolve) {
                        return setTimeout(resolve, 200);
                      });
                    case 12:
                      _context2.n = 13;
                      return withTimeout(_apex["default"].connection.RPCPromise('SubscribeLevel2', {
                        OMSId: 1,
                        InstrumentId: instrumentId,
                        Depth: 250
                      }), RPC_TIMEOUT_MS, 'SubscribeLevel2');
                    case 13:
                      resubscribeRes = _context2.v;
                      if (resubscribeRes && resubscribeRes.o) {
                        _data = JSON.parse(resubscribeRes.o);
                        if (_data && Array.isArray(_data) && _data.length > 0) {
                          _currentId = store.getState().apexCore.instrument.selectedInstrumentId;
                          if (_currentId === instrumentId) {
                            _mappedData = _data.map(function (x) {
                              return new _alphapointApexApi.Level2(x);
                            });
                            store.dispatch((0, _level2Actions.getAllLevel2)(_mappedData));
                          }
                        }
                      }
                      _context2.n = 15;
                      break;
                    case 14:
                      _context2.p = 14;
                      _t3 = _context2.v;
                      console.error('Failed to recover via resubscribe:', _t3);
                    case 15:
                      _context2.n = 17;
                      break;
                    case 16:
                      console.error('Level2 subscription failed:', _t);
                      throw _t;
                    case 17:
                      return _context2.a(2);
                  }
                }, _callee2, null, [[10, 14], [6, 8], [3, 5]]);
              }))(), SUBSCRIBE_TIMEOUT_MS, 'subscribe()');
            case 4:
              _context3.p = 4;
              subscriptionInProgress = false;

              // If there's a pending subscription, process it now
              if (pendingSubscriptionInstrumentId) {
                pending = pendingSubscriptionInstrumentId;
                pendingSubscriptionInstrumentId = null;

                // Only process if it's still the selected instrument
                currentInstrumentId = store.getState().apexCore.instrument.selectedInstrumentId;
                if (pending === currentInstrumentId) {
                  subscribe()["catch"](function (err) {
                    console.error('Level2 pending subscription failed:', err);
                  });
                }
              }
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, null, [[3,, 4, 5]]);
      }));
      return _subscribe.apply(this, arguments);
    }
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(action) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(action.type === _level2Actions.SUBSCRIBE_LEVEL2)) {
                _context.n = 2;
                break;
              }
              if (!(action.payload.instrumentId === _level2SubscriptionService["default"].initializedInstrumentId)) {
                _context.n = 1;
                break;
              }
              console.log('Already subscribed for level 2 for this instrument. Skipping');
              return _context.a(2);
            case 1:
              subscribe()["catch"](function (err) {
                console.error('Level2 subscription failed:', err);
              });
              if (intervalSingleton) {
                clearInterval(intervalSingleton);
                intervalSingleton = null;
              }
              intervalSingleton = setInterval(function () {
                var state = store.getState();
                if (orderBookSanityCheck(state)) {
                  subscribe()["catch"](function (err) {
                    console.error('Level2 sanity-check resubscription failed:', err);
                  });
                }
              }, level2MonitorInterval);
              _context.n = 3;
              break;
            case 2:
              if (action.type === _level2Actions.UNSUBSCRIBE_LEVEL2) {
                if (_level2SubscriptionService["default"].isInitialized()) {
                  _level2SubscriptionService["default"].stop();
                }
                clearInterval(intervalSingleton);
                intervalSingleton = null;
              }
            case 3:
              return _context.a(2, next(action));
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};
var _default = exports["default"] = level2monitor;